import React from 'react'
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import  BreadCrumb  from "app/components/BreadCrumb";
import { AddButton } from 'app/components/Button/AddButton';
import { useTranslation } from "react-i18next";
import { useInjectReducer } from "redux-injectors";
import { reducer, sliceKey } from "./redux/slice";


import { useStyles } from "./styles";
import AdminTemplateTable from "./components/adminTemplateTable"
import {
  selectTemplates,
  selectIsLoading,
  selectError
} from "./redux/selector";


const AdminTemplate = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();
const rows = useSelector(selectTemplates)
const loading = useSelector(selectIsLoading) 

useInjectReducer({
  key: sliceKey,
  reducer,
});





    
  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.DOCUMENT_TEMPLATES")} iconPosition="end" />
            <Box>
              <AddButton label={t(("ADMIN_TEMPLATE.ADD"))}/>
            </Box>
            <AdminTemplateTable rows={rows} loading={loading}/>
          </Box>
        </Box>
    </Box>
  )
}

export default AdminTemplate
